
import { FaBoxes } from "react-icons/fa";
import { BiListPlus } from "react-icons/bi";

import { PeriodProvider } from "@/providers/Period";
import { lazy } from "react";

const Abastecimento = lazy(() => import("./Abastecimento"));
const Gestao = lazy(() => import("./AcompanhamentoAbatecimento"));

const ModuleAbastecimento = {
  menuItem: {
    to: "/abastecimento",
    title: "Abastecimento",
    icon: FaBoxes,
    id: 10,
    childrens: [
      {
        to: "/abastecimento",
        title: "Criar",
        icon: BiListPlus,
        fullTitle: "Abastecimento",
        id: 50
      },
      {
        to: "/abastecimento/gestao",
        title: "Gestão",
        fullTitle: "gestao",
        id: 50
      },
    ],
  },

  routes: [
    {
      path: "/abastecimento",
      element: <Abastecimento />,
    },
    {
      path: "/abastecimento/gestao",
      element: (
        <PeriodProvider>
          <Gestao />
        </PeriodProvider>
      ),
    },

  ],
};

export default ModuleAbastecimento;
